/* Brands page: client-side pagination over the letter group cards (there's
   no native Liquid `paginate` support for an arbitrary array like
   shop.vendors), plus the A-Z nav jumping to / paging to the right group. */
(function () {
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState === 'complete' || document.readyState === 'interactive') init();

  function init() {
    const grid = document.querySelector('[data-hdt-brands-grid]');
    if (!grid) return;

    const groups = Array.from(grid.querySelectorAll('[data-hdt-brands-group]'));
    const pagination = document.querySelector('[data-hdt-brands-pagination]');
    const pagesWrapper = document.querySelector('[data-hdt-brands-pages]');
    const prevButton = document.querySelector('[data-hdt-brands-prev]');
    const nextButton = document.querySelector('[data-hdt-brands-next]');
    const showAllButton = document.querySelector('[data-hdt-brands-show-all]');
    const navLinks = Array.from(document.querySelectorAll('[data-hdt-brands-nav-link]'));

    const totalPages = groups.reduce((max, group) => Math.max(max, parseInt(group.dataset.page, 10) || 1), 1);
    let currentPage = 1;
    let showingAll = true;

    if (totalPages > 1 && pagination) {
      pagination.hidden = false;
      for (let page = 1; page <= totalPages; page += 1) {
        const pageButton = document.createElement('button');
        pageButton.type = 'button';
        pageButton.className = 'hdt-brands-pagination__page';
        pageButton.textContent = String(page);
        pageButton.dataset.page = String(page);
        pageButton.addEventListener('click', () => goToPage(page));
        pagesWrapper.appendChild(pageButton);
      }
    }

    function render() {
      groups.forEach((group) => {
        const groupPage = parseInt(group.dataset.page, 10) || 1;
        group.hidden = !showingAll && groupPage !== currentPage;
      });

      if (pagination) {
        pagesWrapper.querySelectorAll('.hdt-brands-pagination__page').forEach((button) => {
          button.classList.toggle('is-active', !showingAll && parseInt(button.dataset.page, 10) === currentPage);
        });
        if (prevButton) prevButton.disabled = showingAll || currentPage <= 1;
        if (nextButton) nextButton.disabled = showingAll || currentPage >= totalPages;
      }

      if (showAllButton) showAllButton.classList.toggle('is-active', showingAll);
    }

    function goToPage(page) {
      showingAll = false;
      currentPage = Math.min(Math.max(page, 1), totalPages);
      render();
    }

    if (showAllButton) {
      showAllButton.addEventListener('click', () => {
        showingAll = true;
        render();
      });
    }

    if (prevButton) prevButton.addEventListener('click', () => goToPage(currentPage - 1));
    if (nextButton) nextButton.addEventListener('click', () => goToPage(currentPage + 1));

    navLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href').slice(1);
        const target = document.getElementById(targetId);
        if (!target) return;
        event.preventDefault();
        const targetPage = parseInt(target.dataset.page, 10) || 1;
        if (targetPage !== currentPage || showingAll) {
          showingAll = false;
          currentPage = targetPage;
          render();
        }
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    render();
  }
})();
